<template>
<b-container v-if="this.getEstablecimiento">
  <tabla-cargo-personal :seleccionable="true"></tabla-cargo-personal>
  <registrar-solicitud-form
    v-on:form-solicitud-close="cerrarModal($event)"
    :personal="this.Personal"
    :cargopersonal="this.ListaCargoPersonal">
  </registrar-solicitud-form>
</b-container>
</template>

<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import axios from 'axios';
import moment from 'moment';
import qs from 'qs';
import LicenciaCargoPersonalSvc from '@/services/licenciacargopersonal'

import RegistrarSolicitudForm from './RegistrarSolicitudForm.vue'

import TablaHistorialSolicitud from '../../common/TablaHistorialSolicitud.vue'
import TablaCargoPersonal from '../../common/TablaCargoPersonal.vue'
import FormBuscarPersonal from '../../common/FormBuscarPersonal.vue';


import { createHelpers } from 'vuex-map-fields';



const { mapFields: mapSolicitudFields } = createHelpers({
  getterType: 'FormSolicitudModule/getSolicitudField',
  mutationType: 'FormSolicitudModule/updateSolicitudField',
});

const { mapFields: mapFormBuscarPersonalFields } = createHelpers({
  getterType: 'FormBuscarPersonal/getFormBuscarPersonalField',
  mutationType: 'FormBuscarPersonal/updateFormBuscarPersonalField',
});

export default {
  name: "RegistrarSolicitud",
  mixins: [errorhandler, swalerts],
  components: { RegistrarSolicitudForm, TablaHistorialSolicitud, FormBuscarPersonal, TablaCargoPersonal },
  computed: {
    ...mapGetters(['getEstablecimiento', 'isInRoleAdmin', 'isInRoleCoordinador', 'isInRoleEstablecimiento', 'isInRoleRecMedico']),
    ...mapSolicitudFields(['TipoLicencia', 'DetalleDiasLicencia', 'EstadoSolicitudMedica', 'FechaDesde', 'Observaciones', 'CantidadDias', 'ListaCargoPersonalSeleccionado' ]),
    ...mapFormBuscarPersonalFields(['Personal', 'ListaCargoPersonal', 'Dni'])
  },

  data() {
    return {
      modalRegistrar:
      {
        headerBackground:'dark',
        title: '',
        content: '',
      },
      articuloSeleccionado:null,
      solicitudseleccionada:null,
      listacargosagregar:[],
      disabled:null,
      unidadId:'',
      nivelSolicitud : '',
      infoContacto: [],
      datosDocente: [],
      arregloLicencias: [],

      status: '',
      allCargosSelected:false,
      inputDniSearch: null
    }
  },
  mounted(){
    this.ListaCargoPersonalSeleccionado = [];
  },
  methods: {
    articuloTrigger(articulo){
      console.log(articulo);
      if(articulo === 'Articulo 32'){
        console.log('mostrar formulario 32');
        this.ausenteDesdeVisible = false;
      }else{
        console.log('ocultar formulario 32');
        this.ausenteDesdeVisible = true;
      }
    },

    findLicenciaCargoPersonal() {
      return LicenciaCargoPersonalSvc.findl({
        Personal_Id: this.id,
        IncluyeCargoPersonal: true,
        IncluyeUsuarioCarga: true
      });
    },
    limpiar() {
      this.datosDocente = [];
      this.cantDiasSinTrabajar = 0;
    },
    cerrarModal(mensaje){
      if(mensaje){
        this.showSuccess(mensaje);
      }
      this.$router.push({ name: 'consultasolicitud', params: {  } });
    },
    obtenerFechaHasta() {
      var fechaRetornada = moment(this.txtFechaActual).add(this.txtCantidadDias, 'days').subtract(1, 'days').format();
      return fechaRetornada;
    },

    porcentajeDias() {
      return this.diasSinTrabajar;
    },
    cantDiasAnio() {
      return 365
    },



  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/pages/solicitudes/RegistrarSolicitudPersonal.vue